import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import AxiosUrl from "../AxiosUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

function EditWithdrawModal({ setOpenModal, data, setRefresh }) {
  const uid = localStorage.getItem("id");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(data.Status);
  const [amount, setAmount] = useState(data.Amount);
  const [number, setNumber] = useState(data.Number);
  const [type, setType] = useState(data.Type);

  const handleClose = () => setOpenModal(false);

  const handleSave = () => {
    setLoading(true);

    const formData = {
      withdrawId: data._id,
      newStatus: status,
    };

    AxiosUrl.post(`/update-withdraw/${uid}`, formData)
      .then((res) => {
        toast.success("Withdrawal updated successfully");
        setRefresh((prev) => prev + 1);
        handleClose();
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to update withdrawal:", error);
        toast.error("Failed to update withdrawal");
        setLoading(false);
      });
  };

  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Modal
      open={true}
      onClose={handleClose}
      aria-labelledby="edit-withdraw-title"
      aria-describedby="edit-withdraw-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isMobile ? 290 : 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 3,
          overflowY: "auto",
        }}
      >
        <ToastContainer />
        <h2
          style={{
            margin: 0,
            textTransform: "uppercase",
            color: "#1e2124",
            background: "aliceblue",
            padding: "10px",
            borderRadius: "5px",
            textAlign: "center",
          }}
        >
          Update Withdrawal
        </h2>

        {/* Display User Name */}
        <TextField
          label="User Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={data.user?.username || "Unknown User"}
          InputProps={{ readOnly: true }}
        />
        <TextField
          label="Account Mobile"
          variant="outlined"
          fullWidth
          margin="normal"
          value={data.user?.mobile || "Unknown User"}
          InputProps={{ readOnly: true }}
        />
        <TextField
          label="Bkash Number"
          variant="outlined"
          fullWidth
          margin="normal"
          value={number}
          onChange={(e) => setNumber(e.target.value)}
          InputProps={{ readOnly: true }}
        />

        <TextField
          label="Amount"
          variant="outlined"
          fullWidth
          margin="normal"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          InputProps={{ readOnly: true }}
        />

        <FormControl fullWidth margin="normal">
          <InputLabel id="type-label">Type</InputLabel>
          <Select
            labelId="type-label"
            value={type}
            label="Type"
            onChange={(e) => setType(e.target.value)}
          >
            <MenuItem value="Bkash">Bkash</MenuItem>
            <MenuItem value="Nagad">Nagad</MenuItem>
            <MenuItem value="Rocket">Rocket</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel id="status-label">Status</InputLabel>
          <Select
            labelId="status-label"
            value={status}
            label="Status"
            onChange={(e) => setStatus(e.target.value)}
          >
            <MenuItem value={0}>Pending</MenuItem>
            <MenuItem value={1}>Approved</MenuItem>
            <MenuItem value={2}>Rejected</MenuItem>
          </Select>
        </FormControl>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          fullWidth
          sx={{ mt: 2, p: 1 }}
        >
          {loading ? "Loading..." : "Update Withdrawal"}
        </Button>
        <Button
          variant="outlined"
          onClick={handleClose}
          fullWidth
          sx={{
            mt: 2,
            p: 1,
            color: "white",
            borderColor: "red",
            backgroundColor: "red",
            "&:hover": {
              backgroundColor: "darkred",
              borderColor: "darkred",
            },
          }}
        >
          Close
        </Button>
      </Box>
    </Modal>
  );
}

export default EditWithdrawModal;
